import styled from 'styled-components';

export const StyledLightningAlarm = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  box-shadow: 0px 6px 24px 0px #0000001f;
  border: 1px solid #e0e0e0;
  width: 780px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  z-index: 100;

  .lam-header {
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    border-bottom: 1px solid #eeeeee;
    flex-shrink: 0;
    cursor: grab;
    user-select: none;

    &:active {
      cursor: grabbing;
    }
  }

  .lam-title {
    font-size: 18px;
    font-weight: 600;
    color: #2f2f35;
  }

  .lam-close-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .lam-body {
    display: flex;
    flex-direction: row;
    flex: 1;
    padding: 20px 24px;
    gap: 24px;
    min-height: 0;
  }

  .lam-map {
    flex: 0 0 420px;
    background-color: #cccccc;
    border-radius: 8px;
    overflow: hidden;
  }

  .lam-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
    overflow-y: auto;
  }

  .lam-section {
    display: flex;
    flex-direction: column;
  }

  .lam-section-title {
    font-size: 16px;
    font-weight: 500;
    color: #2f2f35;
    margin-bottom: 10px;
  }

  .lam-divider {
    height: 1px;
    background-color: #e8e8e8;
    margin-bottom: 10px;
  }

  .lam-zone-all {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 0 10px;
    font-size: 14px;
    color: #2f2f35;
    cursor: pointer;

    input[type='checkbox'] {
      width: 16px;
      height: 16px;
      cursor: pointer;
      appearance: none;
      -webkit-appearance: none;
      border: 1.5px solid #dadada;
      border-radius: 3px;
      background-color: #ffffff;

      &:checked {
        background-color: #1a50a0;
        border-color: #1a50a0;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='8' viewBox='0 0 10 8'%3E%3Cpath d='M1 4l3 3 5-6' stroke='%23fff' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
      }
    }
  }

  .lam-zone-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 10px;
    column-gap: 8px;
    padding: 4px 0;
  }

  .lam-checkbox-label {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #2f2f35;
    cursor: pointer;

    input[type='checkbox'] {
      width: 16px;
      height: 16px;
      cursor: pointer;
      appearance: none;
      -webkit-appearance: none;
      border: 1.5px solid #dadada;
      border-radius: 3px;
      background-color: #ffffff;

      &:checked {
        background-color: #1a50a0;
        border-color: #1a50a0;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='8' viewBox='0 0 10 8'%3E%3Cpath d='M1 4l3 3 5-6' stroke='%23fff' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
      }
    }
  }

  .lam-section-desc {
    font-size: 14px;
    font-weight: 400;
    color: #585959;
    line-height: 1.5;
    margin: 0 0 12px;
  }

  .lam-level-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .lam-level-item {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 10px 16px;
    border: 0.5px solid #dadada;
    border-radius: 10px;
    cursor: pointer;
    transition: border-color 0.15s;
  }

  .lam-level-item.active {
    border-color: #055cb4;
  }

  .lam-lv {
    font-size: 14px;
    font-weight: 600;
    color: #2f2f35;
    width: 36px;
    flex-shrink: 0;
  }

  .lam-play-btn {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: none;
    background-color: #eeeeee;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    pointer-events: none;
  }

  .lam-level-name {
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .lam-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px 20px;
    border-top: 1px solid #eeeeee;
  }

  .lam-footer-status {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 120px;
  }

  .lam-footer-btns {
    display: flex;
    gap: 10px;
  }

  .lam-status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;

    &.started {
      background-color: #22c55e;
    }

    &.stopped {
      background-color: #a4a7a7;
    }
  }

  .lam-status-text {
    font-size: 13px;
    color: #585959;
  }

  .lam-btn {
    width: 100px;
    height: 37px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .lam-btn-stop {
    background-color: #f8f8f8;
    border: 1px solid #dadada;
    color: #a4a7a7;
  }

  .lam-btn-start {
    background-color: #055cb4;
    border: none;
    color: #ffffff;
  }
`;
